import type { EntityRegistry } from '@sites/entity-migrator';

import {
    DefaultSectionEntitySchema,
    SpecificSectionEntitySchema,
    ZeroSectionEntitySchema,
    isZeroSectionContext,
    type SectionEntity,
} from './schemas';

export const sectionRegistry: EntityRegistry<SectionEntity> = {
    name: 'section',
    getEntitySchema: (entity: unknown, ctx) => {
        if (typeof entity !== 'object' || entity === null) return null;

        const { entitySubType, version, type } = entity as {
            entitySubType?: unknown;
            version?: unknown;
            type?: unknown;
        };

        if (entitySubType === 'default') return DefaultSectionEntitySchema;
        if (entitySubType === 'specific') return SpecificSectionEntitySchema;
        if (entitySubType === 'zero') return ZeroSectionEntitySchema;

        // Pre-versioning sections carry neither subtype nor version. `specific`
        // tags itself; the other two are byte-identical, so a zero row is only
        // recognisable through the block that holds it.
        if (entitySubType === undefined && version === undefined) {
            if (type === 'specific') return SpecificSectionEntitySchema;
            if (isZeroSectionContext(ctx)) return ZeroSectionEntitySchema;
            return DefaultSectionEntitySchema;
        }

        return null;
    },
};
